import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { motion } from 'framer-motion';
import './styles/pages.css';

const InviteHome = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (user) {
      navigate('/Playground/Inviteapp/templates');
    } else {
      navigate('/login', { state: { from: '/Playground/Inviteapp/templates' } });
    }
  };

  return (
    <div className="inviteapp-home-page">
      <div className="floating-emojis">
        {['\uD83D\uDC95', '\uD83D\uDC8C', '\u2728', '\uD83D\uDC96', '\uD83C\uDF39', '\uD83D\uDC8D'].map((emoji, i) => (
          <motion.span
            key={i}
            className="floating-emoji"
            animate={{
              y: [0, -20, 0],
              rotate: [0, 10, -10, 0],
            }}
            transition={{
              duration: 3 + i * 0.5,
              repeat: Infinity,
              delay: i * 0.3,
            }}
            style={{
              left: `${15 + i * 15}%`,
              top: `${20 + (i % 3) * 20}%`,
            }}
          >
            {emoji}
          </motion.span>
        ))}
      </div>

      <motion.div
        className="home-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <motion.h1
          className="logo"
          animate={{ scale: [1, 1.02, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          {'\uD83D\uDC8C'} Irresistible Invites
        </motion.h1>

        <p className="tagline">
          Create fun invitations that make it <em>impossible</em> to say no!
        </p>

        <div className="features">
          <div className="feature">
            <span className="feature-icon">{'\uD83D\uDC95'}</span>
            <span>Valentine's Day</span>
          </div>
          <div className="feature">
            <span className="feature-icon">{'\uD83C\uDF19'}</span>
            <span>Date Nights</span>
          </div>
          <div className="feature">
            <span className="feature-icon">{'\uD83D\uDC8D'}</span>
            <span>Proposals</span>
          </div>
        </div>

        {user ? (
          <div className="user-section">
            <p className="welcome">Welcome, {user.name?.split(' ')[0] || 'there'}! {'\uD83D\uDC4B'}</p>
            <motion.button
              className="cta-button"
              onClick={() => navigate('/Playground/Inviteapp/templates')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Create Invite {'\u2728'}
            </motion.button>
          </div>
        ) : (
          <motion.button
            className="cta-button"
            onClick={handleGetStarted}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Started {'\u2728'}
          </motion.button>
        )}
      </motion.div>

      <footer className="home-footer">
        <p>Made with {'\uD83D\uDC96'} for spreading love</p>
      </footer>
    </div>
  );
};

export default InviteHome;
